export function mulberry32(seed: number): () => number {
  let a = seed >>> 0
  return () => {
    a |= 0
    a = (a + 0x6d2b79f5) | 0
    let t = Math.imul(a ^ (a >>> 15), 1 | a)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

export function pick<T>(random: () => number, values: readonly T[]): T {
  return values[Math.floor(random() * values.length)] as T
}

export function pickBy<T>(random: () => number, values: readonly T[], weight: (value: T) => number = () => 1): T {
  const total = values.reduce((sum, value) => sum + weight(value), 0)
  let cursor = random() * total
  for (const value of values) {
    cursor -= weight(value)
    if (cursor <= 0) return value
  }
  return values[values.length - 1] as T
}

export function intBetween(random: () => number, min: number, max: number): number {
  return Math.floor(random() * (max - min + 1)) + min
}

export function pad(value: number): string {
  return String(value).padStart(2, '0')
}

export function clock(hour: number, minute: number): string {
  return `${pad(hour)}:${pad(minute)}`
}
